import { BaseFetch } from "../main-model";
export default class StudentInScholarshipModel extends BaseFetch {
    getStudentInScholarshipBy = (data) =>
    this.authFetch({
      url: "student-in-scholarship/getStudentInScholarshipBy",
      method: "POST",
      body: JSON.stringify(data),
    });
    getStudentInScholarshipById = (data) =>
    this.authFetch({
      url: "student-in-scholarship/getStudentInScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
    insertStudentInScholarship = (data) =>
    this.authFetch({
      url: "student-in-scholarship/insertStudentInScholarship",
      method: "POST",
      body: JSON.stringify(data),
    });
    updateStudentInScholarshipById = (data) =>
    this.authFetch({
      url: "student-in-scholarship/updateStudentInScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
    deleteStudentInScholarshipById = (data) =>
    this.authFetch({
      url: "student-in-scholarship/deleteStudentInScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
    deleteAllStudentInScholarshipById = (data) =>
    this.authFetch({
      url: "student-in-scholarship/deleteAllStudentInScholarshipById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
